import { render, staticRenderFns } from "./BannerNotice.vue?vue&type=template&id=57db3e74&scoped=true"
import script from "./BannerNotice.vue?vue&type=script&lang=ts"
export * from "./BannerNotice.vue?vue&type=script&lang=ts"
import style0 from "./BannerNotice.vue?vue&type=style&index=0&id=57db3e74&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db3e74",
  null
  
)

export default component.exports